import styles from './paymentTypeField.module.css'
import { FieldType, FieldValue, FormField, option, Option } from "../../../../../features/ui";
import { TableName } from "../../../../../tables";
import { useDataTypesHooks } from "../../../../../features/data-types";
import { usePaymentTypeLoaders } from '../../../loaders/paymentTypeLoaders';
import { PaymentType } from '../../../state/types';
import { isSelectablePaymentType } from '../../../utils/paymentTypeUtils';
import { useMemo } from 'react';

type Props = {
    defaultValue?: string
    value?: string
    paymentTypes?: PaymentType[]
    narrow?: boolean
    hideAdjustments?: boolean
    onChange?: (value?: FieldValue) => void
}

export const PaymentTypeField = (props: Props): FormField => {
    const { defaultValue, value, paymentTypes, narrow = true, hideAdjustments, onChange } = props
    
    const { formatValue } = useDataTypesHooks()

    const paymentTypeLoaders = usePaymentTypeLoaders()

    const options = useMemo(() => paymentTypes?.filter(paymentType => isSelectablePaymentType(paymentType, defaultValue))
        .map(paymentType => option(paymentType.id, paymentType.name))
    , [paymentTypes])

    const renderPaymentTypeOption = async (
        option: Option,
        onClick?: (e: React.MouseEvent<HTMLElement>) => void
    ) => {
        const { findPaymentType } = paymentTypeLoaders()
        const paymentType = findPaymentType(option.value)
        if (!paymentType) return <></>
        return (
            <div className={styles.paymentTypeOption} onClick={onClick}>
                <span>{paymentType.name}</span>
                <span className={styles.paymentTypeYield}>
                    {formatValue(paymentType.yield, FieldType.PERCENTAGE)}
                </span>
            </div>
        )
    }

    return {
        name: 'paymentTypeId',
        type: FieldType.TABLE,
        table: TableName.PAYMENT_TYPES,
        defaultValue,
        value,
        label: 'Medio de Pago',
        options,
        narrow,
        renderOption: !hideAdjustments ? renderPaymentTypeOption : undefined,
        onChange
    }
}
